import { render, staticRenderFns } from "./AppBarControl.global.vue?vue&type=template&id=487dede1&lang=pug&"
import script from "./AppBarControl.global.vue?vue&type=script&lang=ts&"
export * from "./AppBarControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports